import React from "react";
import { Grid, Typography } from "@mui/material";
import { QuestionTypesMST, QuestionTypesRu } from "../../../../../static/enums/Questions";
import { Skill } from "../../../../../mobx/stores/skills/models";
import { Topic } from "../../../../../mobx/stores/topics/models";

interface QuestionRenderDescriptionProps {
	type: typeof QuestionTypesMST[number];
	difficulty: number;
	topics: Topic[];
	skills: Skill[];
}

export default function QuestionRenderDescription({
	skills,
	difficulty,
	type,
	topics,
}: QuestionRenderDescriptionProps) {
	return (
		<Grid container direction={"column"} item>
			<Grid container alignItems={"center"} item columnSpacing={1}>
				<Grid item>
					<Typography variant={"subtitle2"} component={"div"}>
						Тип:{" "}
					</Typography>
				</Grid>
				<Grid item>
					<Typography variant={"body1"} component={"div"}>
						{QuestionTypesRu[type]}
					</Typography>
				</Grid>
			</Grid>
			<Grid item>
				<Grid container alignItems={"center"} item columnSpacing={1}>
					<Grid item>
						<Typography variant={"subtitle2"}>Сложность:</Typography>
					</Grid>
					<Grid item>
						<Typography variant={"body1"}>{difficulty}/10</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Typography variant={"subtitle2"}>Темы:</Typography>
				<Grid item>
					<Typography variant={"body1"}>{topics.map((topic) => topic.title).join(", ")}</Typography>
				</Grid>
			</Grid>
			<Grid item>
				<Typography variant={"subtitle2"}>Навыки:</Typography>
				<Grid item>
					<Typography variant={"body1"}>{skills.map((skill) => skill.title).join(", ")}</Typography>
				</Grid>
			</Grid>
		</Grid>
	);
}
